<mat-card-content fxLayout="column" fxLayoutGap="3rem">
    <mat-list fxLayout="row">
        <mat-list-item>
            <img mat-card-avatar src="/assets/material-icon/alarm_FILL0_wght400_GRAD0_opsz48.svg"
                 style="margin-right: 15px;"/>
            <div fxLayout="column">
                <div matCardSubtitle>Abgabefrist</div>
                <div matCardTitle>{{datenabfrage.abgabefrist | date: 'dd.MM.yyyy'}}</div>
            </div>
        </mat-list-item>
        <mat-list-item>
            <img mat-card-avatar src="/assets/material-icon/pending_actions_FILL0_wght400_GRAD0_opsz48.svg"
                 style="margin-right: 15px;"/>
            <div fxLayout="column">
                <div matCardSubtitle>Referenzzeitraum Erzeugerleistung</div>
                <div
                    matCardTitle>{{datenabfrage.referenzzeitraumErzeugerleistung | date: 'dd.MM.yyyy' }}</div>
            </div>

        </mat-list-item>
        <mat-divider></mat-divider>
        <mat-list-item>
            <img mat-card-avatar src="/assets/material-icon/event_note_FILL0_wght400_GRAD0_opsz48.svg"
                 style="margin-right: 15px;"/>
            <div fxLayout="column">
                <div matCardSubtitle>Referenzzeitraum Endverbraucherlast</div>
                <div
                    matCardTitle>{{datenabfrage.referenzzeitraumEndverbraucherlast | date: 'dd.MM.yyyy'}}</div>
            </div>
        </mat-list-item>
    </mat-list>

    <tnb-aufteilungsschluessel-list
        [aufteilungsSchluessels]="aufteilungsSchluessels"></tnb-aufteilungsschluessel-list>
</mat-card-content>
